// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZT6RF","badges":"styles_badges__37byK"};